import { fetchServerData } from '@shared/utils/fetchServerData/fetchServerData';

import { PersonalAccountAddressInfoType } from '../../';

export const getAddressInfo = async (cookie: string) => {
  return await fetchServerData<PersonalAccountAddressInfoType>('v2/user/address', { headers: { cookie } });
};
